export default __webpack_public_path__ + "static/media/ic-remove.5027f516.svg";